
export const getOperatorCode = () => {

    let data = localStorage.getItem('operatorCode');
    if (data){
      return data;
    }else{
      return window.location.pathname.split("/")[1].toUpperCase(); 
    }
  };